var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-container"},[_c('div',{staticClass:"step",on:{"click":_vm.decrease}},[_c('minus')],1),_c('span',[_vm._v(_vm._s(_vm.model))]),_c('div',{staticClass:"step",on:{"click":_vm.increase}},[_c('plus')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }